import { render, staticRenderFns } from "./TipoContratacion.vue?vue&type=template&id=226252e8"
import script from "./TipoContratacion.vue?vue&type=script&lang=js"
export * from "./TipoContratacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports